var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    { staticClass: "main", attrs: { role: "main" } },
    [
      _c("Overlay", { attrs: { active: _vm.overlayActive } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inner wrapper" },
        [
          _c("BicTitle", { attrs: { term: _vm.term, mode: _vm.mode } }),
          _vm._v(" "),
          _c("Message", {
            attrs: { messageType: _vm.messageType, message: _vm.message },
          }),
          _vm._v(" "),
          _c("MainForm", {
            attrs: {
              term: _vm.term,
              mode: _vm.mode,
              nbResults: _vm.nbResults,
              routeName: _vm.routeName,
              helpForSearchTerm: _vm.helpForSearchTerm,
              industry: _vm.industry,
              industryOptions: _vm.industryOptions,
              sector: _vm.sector,
              sectorOptions: _vm.sectorOptions,
              category: _vm.category,
              categoryOptions: _vm.categoryOptions,
              industryLoading: _vm.industryLoading,
              sectorLoading: _vm.sectorLoading,
              categoryLoading: _vm.categoryLoading,
              searchSubmit: _vm.searchSubmit,
              browseSubmit: _vm.browseSubmit,
              updateIndustry: _vm.updateIndustry,
              updateSector: _vm.updateSector,
              updateCategory: _vm.updateCategory,
            },
          }),
          _vm._v(" "),
          _c("Loading", { attrs: { loading: _vm.loading } }),
          _vm._v(" "),
          _c("Toolbar", {
            attrs: {
              nbResults: _vm.nbResults,
              nbSelected: _vm.nbSelected,
              linkSelected: _vm.linkSelected,
              showSelected: _vm.showSelected,
              displayList: _vm.displayList,
              setShowSelected: _vm.setShowSelected,
              clearWatchlist: _vm.clearWatchlist,
              setDisplayList: _vm.setDisplayList,
            },
          }),
          _vm._v(" "),
          _c("BicList", {
            attrs: {
              items: _vm.bics,
              itemsSelected: _vm.bicsSelected,
              alternateBicSource: _vm.alternateBicSource,
              alternateBic: _vm.alternateBic,
              itemsHelp: _vm.bicsHelp,
              addToWatchlist: _vm.addToWatchlist,
              removeFromWatchlist: _vm.removeFromWatchlist,
              toggleBicsHelp: _vm.toggleBicsHelp,
              getAlternateBic: _vm.getAlternateBic,
              clearAlternateBic: _vm.clearAlternateBic,
              showSelected: _vm.showSelected,
              displayList: _vm.displayList,
              setDisplayList: _vm.setDisplayList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("BicFooter", { attrs: { mode: _vm.mode } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }